export const styles = {
	textFieldContainer: {
		flexGrow: 1,
	},
	containerGrid: {
		pb: 2,
		pt: 1,
		width: '100%',
	},
	flexGrid: {
		alignItems: 'stretch',
		justifyContent: 'flex-start',
	},
	circularProgressIcon: {
		color: 'secondary.main',
		size: '2.8rem',
	},
	textField: {
		'& .MuiOutlinedInput-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderWidth: '1px',
				borderColor: '#93A2AF',
			},
			'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
				borderWidth: '1px',
				borderColor: 'secondary.main',
			},
			'&:hover .MuiOutlinedInput-notchedOutline': {
				borderWidth: '1px',
				borderColor: 'secondary.main',
			},
		},
		'& .MuiInputBase-input': {
			boxSizing: 'content-box',
			height: '100%',
		},
	},
	inputLabel: {
		color: '#93A2AF',
	},
}
